import { styled } from "@mui/material";

export const InlineCode = styled("span")(({ theme }) => ({
  display: "inline",
  fontFamily: "monospace",
  background: theme.palette.overlay.min,
}));
